<template>
  <div class="logout-page">
    <div class="mdl-card mdl-shadow--2dp">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ i18n()[state].title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <p>{{ i18n()[state].text }}</p>
        <router-link :to="{ name: 'login' }" v-if="state=='done'"
                     class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored" type="submit">
          {{ i18n().login }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from "i18n"
  import api from "api"

  export default {
    name: 'login-form',
    metaInfo: {
      title: i18n().user.logout.title
    },
    data () {
      return {
        error: null,
        email: "",
        password: "",
        required: false,
      }
    },
    computed: {
      state() {
        return api.session.loggedIn ? 'working' : 'done'
      }
    },
    methods: {
      i18n() { return i18n().user.logout }
    },
    updated () {
    },
    mounted () {
      api.request(["session", "logout"],{}).then(ok => {
        // ??
      })
    }
  }
</script>

<style scoped>

  .logout-page {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../../../static/images/voleadstools2.png);
    background-position: center;
    background-size: 280%;
  }

  .mdl-card {
    width: 320px;
    margin: auto;
  }
  .mdl-card__title {
    height: 110px;
    color: #fff;
    background: url(../../../static/images/voleadstools2_mid.png) 215px 5px no-repeat #241d7f;
    background-size: 100px;
  }

  button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// Logout.vue?4fe4262a